import { c as _c } from "react/compiler-runtime";
import styled, { css, useTheme } from 'styled-components';
import useIsSticking from '../../hooks/useIsSticking';
import { Div } from '../helpers/StyledUtils';
const StyledStickingCollapsableSection = styled(Div)<{
  embedded?: boolean;
  collapsed?: boolean;
}>(({
  theme,
  embedded,
  collapsed
}) => css`
    padding: ${embedded ? `${theme.spacing(3)} ${theme.spacing(6)}` : theme.spacing(0)};
    margin-bottom: ${embedded ? theme.spacing(0) : collapsed ? theme.spacing(4) : theme.spacing(3)};
    box-sizing: border-box;
    width: ${embedded ? '100%' : 'auto'};
    display: flex;
    align-items: center;
    gap: ${theme.spacing(2)};
    justify-content: ${embedded ? 'space-between' : 'flex-start'};

    > * {
      &:hover {
        cursor: pointer;
        background-color: transparent !important;
      }
    }
  `);
export const CollapsableDataSection = t0 => {
  const $ = _c(14);
  const {
    children,
    collapsed,
    embedded,
    z_index
  } = t0;
  const [ref, is_sticking] = useIsSticking();
  const theme = useTheme();
  const t1 = embedded ? ref : undefined;
  let t2;
  if ($[0] !== collapsed || $[1] !== embedded || $[2] !== is_sticking || $[3] !== theme || $[4] !== z_index) {
    t2 = embedded ? {
      position: "sticky",
      top: 0,
      backgroundColor: !collapsed && is_sticking ? theme.colors.surface.base.variant_surface_3 : undefined,
      zIndex: is_sticking && !collapsed ? theme.zindex.sticky : z_index,
      borderBottom: is_sticking && !collapsed ? theme.border : undefined
    } : undefined;
    $[0] = collapsed;
    $[1] = embedded;
    $[2] = is_sticking;
    $[3] = theme;
    $[4] = z_index;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== children || $[7] !== collapsed || $[8] !== embedded) {
    t3 = <StyledStickingCollapsableSection embedded={embedded} collapsed={collapsed}>{children}</StyledStickingCollapsableSection>;
    $[6] = children;
    $[7] = collapsed;
    $[8] = embedded;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = <Div ref={t1} style={t2}>{t3}</Div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};